export const fetchPickupPoints = async (url) => {
	const response = await fetch(url);

	const callResponse = await response.json();

	return callResponse.map((point) => ({
		label: `${point.address} ${point.city} ${point.carrierType}`,
		value: point.id,
	}));
};
